export default __webpack_public_path__ + "static/media/google.173162ae.svg";